module.exports = __webpack_public_path__ + "img/b2-3.3680f12.png";